import { render, staticRenderFns } from "./upload-form.vue?vue&type=template&id=68260a5c&scoped=true&"
import script from "./upload-form.vue?vue&type=script&lang=js&"
export * from "./upload-form.vue?vue&type=script&lang=js&"
import style0 from "./upload-form.vue?vue&type=style&index=0&id=68260a5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68260a5c",
  null
  
)

export default component.exports